/** @format */

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import {
  getSupportedFileTypes,
  getQuestionnaireIntro,
  getQuestionnairePage,
  updateUserOnQuestionnaireTrueFalse,
  setUnsetFormValues,
  setUnsetHasError,
  showSpinnerEnableDisable,
  elementUpdated,
  displaySavePOPUP
} from 'src/ui/features/Questionnaire/state/questionnaireActions';

import { QuestionnairePagePres } from '../presentational/QuestionnairePagePres';
import { addToHistory } from 'src/utils/utilsActions';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
class QuestionnairePageContainer extends Component {
  state = {
    formValues: {},
    savingPage: false,
    isMenuClicked: false,
    reloadPage: false,
    showFirstSpinner: true,
  };
  constructor(props) {
    super(props);
    this.handleSave = () => {};
  }
  async componentDidMount() {
    // this.getIntroData();
    const { introData, match } = this.props;
    await this.props.showSpinnerEnableDisable(true);
    this.props.addToHistory(window.location.pathname);
    this.props.updateUserOnQuestionnaireTrueFalse(true);
    this.props.getSupportedFileTypes();
    if (!introData) {
      await this.props.getQuestionnaireIntro({ ...match.params });
    }
    await this.getPageData();
    await this.props.showSpinnerEnableDisable(false);
    this.setState({ showFirstSpinner: false });
  }
  componentWillUnmount() {
    this.props.updateUserOnQuestionnaireTrueFalse(false);
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.match.params.pageId !== this.props.match.params.pageId) {
      //   this.getIntroData();
      this.setState({ showFirstSpinner: true });
      this.props.addToHistory(window.location.pathname);
      await this.getPageData();
      this.setState({ showFirstSpinner: false, savingPage: false });
    }
  }
  toggleReloadPage = () => {
    this.setState({ reloadPage: !this.state.reloadPage });
  };
  getIntroData = () => {
    const { getQuestionnaireIntro, match } = this.props;
    return getQuestionnaireIntro(match.params, false, this.getPageData);
  };
  getPageData = () => {
    const { getQuestionnairePage, match } = this.props;
    const oldLangID = sessionStorage.getItem('language') ? JSON.parse(sessionStorage.getItem('language')).oldLangId : null;
    if (oldLangID !== null) {
      return getQuestionnairePage({
        ...match.params,
        languageId: oldLangID,
      });
    }
    return getQuestionnairePage({
      ...match.params,
    });
  };
  setFormValues = formValues => {
    const { elementUpdated} = formValues;
    const havingError = formValues.isFormComplete === true ? false : this.props.hasError;
    this.props.setUnsetFormValues(formValues);
    this.props.setUnsetHasError(havingError);
    if(elementUpdated!==null) {
      this.props.elementUpdated(true);
    }
  };

  setShowErrors = () => {
    this.props.setUnsetHasError(false);
    setTimeout(() => {
      this.props.setUnsetHasError(true);
    }, 10);
  };

  resetMenuButtonClicked = () => {
    this.setState({ isMenuClicked: false });
  };

  setSaveHandler = handler => {
    this.handleSave = callback => {
      this.setState({ isMenuClicked: true }, () => handler(false, false, true, callback));
    };
  };
  render() {
    const { showFirstSpinner } = this.state;
    return (
      <Fragment>
        {showFirstSpinner && <ServiceSpinner downlaodSpinner={showFirstSpinner} open={true} />}
        <QuestionnairePagePres
          formValues={this.props.formValues}
          setFormValues={this.setFormValues}
          setSaveHandler={this.setSaveHandler}
          setShowErrors={this.setShowErrors}
          onSave={this.handleSave}
          savingPage={this.state.savingPage}
          isShowingErrors={this.props.hasError}
          resetMenuButtonClicked={this.resetMenuButtonClicked}
          isMenuClicked={this.state.isMenuClicked}
          reloadPage={this.state.reloadPage}
          toggleReloadPage={this.toggleReloadPage}
          displaySavePOPUP={this.props.displaySavePOPUP}
          elementUD={this.props.elementUD}
          {...this.props}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  overallProgress: state.questionnaire.overallProgress,
  sectionProgress: state.questionnaire.sectionProgress,
  gettingIntroData: state.questionnaire.gettingIntroData,
  introData: state.questionnaire.intro,
  gettingPageData: state.questionnaire.gettingPageData,
  pageData: state.questionnaire.page,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  formValues: state.questionnaire.formValues,
  hasError: state.questionnaire.hasError,
  showSpinner: state.questionnaire.showSpinner,
  showUserGuide: state.questionnaire.showUserGuide,
  elementUD:state.questionnaire.elementUD,
});

const mapDispatchToProps = {
  getSupportedFileTypes,
  getQuestionnaireIntro,
  getQuestionnairePage,
  push,
  goBack,
  addToHistory,
  updateUserOnQuestionnaireTrueFalse,
  setUnsetFormValues,
  setUnsetHasError,
  showSpinnerEnableDisable,
  elementUpdated,
  displaySavePOPUP
};
export default connect(mapStateToProps, mapDispatchToProps)(QuestionnairePageContainer);



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/containers/QuestionnairePageContainer.js